import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TabularFigures = styled(Box)({
  fontVariantNumeric: 'tabular-nums',
}) as typeof Box;
